import { styled } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox } from '@youscience/core';

export const sxStyles = {
  headTitle: {
    width: '100%',
    fontSize: '2.25rem',
    lineHeight: '3.375rem',
  },
};

export const StyledHero = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  alignSelf: 'stretch',

  minHeight: '10rem',
  padding: '2rem 0rem',
  borderBottom: `1px solid ${coreThemeColors.grey[300]}`,
  background: theme.palette.common.white,
}));

export const StyledHeroMargin = styled(CoreBox)(({ theme }) => ({
  flex: 'auto',
  padding: '0rem 5rem',

  [theme.breakpoints.down('sm')]: {
    padding: '0rem 1rem',
  },
}));

export const StyledHeroContent = styled(CoreBox)(() => ({
  display: 'flex',
  alignSelf: 'stretch',
  flexDirection: 'column',
  gap: '1.5rem',
}));

export const StyledHeroTopContent = styled(CoreBox)(() => ({
  display: 'flex',
  flex: 'auto',
  div: {
    margin: '0',
  },
}));

export const StyledHeroContentColumns = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flex: 'auto',
  flexDirection: 'row',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '1.5rem',
  },
}));

export const StyledHeroBottomContent = styled(CoreBox)(() => ({
  display: 'flex',
  flex: 'auto',
  flexDirection: 'column',
}));

export const StyledHeroLeftContent = styled(CoreBox)(({ theme }) => ({
  paddingTop: '1rem',
  flex: 'auto',
  [theme.breakpoints.down('sm')]: {
    alignSelf: 'stretch',
    padding: '0rem',
  },
}));

export const StyledHeroLeftContentHeadline = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  gap: '1rem',
  flexDirection: 'column',

  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

export const StyledHeroRightContent = styled(CoreBox)(({ theme }) => ({
  padding: '2rem 0rem',
  flex: 'initial',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    alignSelf: 'stretch',
    justifyContent: 'center',
    flex: 'auto',
    padding: '0rem',
  },
}));
